import * as Sentry from "@sentry/vue";
import type { App } from "vue";
import type { Pinia } from "pinia";
import { createSentryPiniaPlugin } from "@sentry/vue";

export function setupSentry(app: App<Element>, pinia: Pinia): void {
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    return;
  }
  Sentry.init({
    app,
    debug: false,
    dsn: "https://e049eb0623fa4dd3280fa25876a14148@o4509083783856128.ingest.de.sentry.io/4510894008369232",
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["*.flixorder.de"],
    environment: import.meta.env.VITE_MODE as string,
  });

  pinia.use(createSentryPiniaPlugin());
}
